import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m13.52 17.743.538 5.067M17.835 12.973l2.385 5.855"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.67 22.269c.613-2.516 1.484-5.543 2.194-6.052 1.29-.892 6.467-2.824 6.402-7.06"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4.508 19.052c.936-2.103 2.29-4.842 2.904-5.065.903-.382 4.29-1.21 3.42-2.325a.93.93 0 0 0-.807-.319c-.968.096-3.517.446-3.936 1.115"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.79 6.294s.43 1.29-1.28 3.297M17.358 4.863s.959 1.129-1.267 3.773M15.45 2.954s1.06-.084.705 1.477c-.355 1.56-.968 2.325-.968 2.325"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.799 6.597s-3.986.553-3.792 2.56"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.528 5.34S12.246 7.675 11 6.5s.874-1.957 2.187-2.228 2.162-2.612-.484-2.23c-2.01.295-3.248 1.079-4.187 2.458"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.638 11.375s1.613-.032 1.678-1.02c.064-.987-2.194-.604-2.194-.604s-3.13.159-3.775.86M10.606 9.591S10.928 8.126 9.735 8c-1.194-.16-3.582.541-3.582.541"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const HandshakeIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
